/**
 * Score component.
 */
import Container from '@components/atoms/container/RatingContainer';
import Denominator from '@components/atoms/text/scoreDenominator';
import Numerator from '@components/atoms/text/scoreNumerator';
import Star from '@components/atoms/icons/star';

/**
 * Constants.
 *
 * @constant {string} DENOMINATOR - Denominator string.
 */
const DENOMINATOR = '/ 5';

/**
 * Props for the Score component.
 *
 * @param {string} score - Score to display
 */
interface Props {
  score?: string;
}

/**
 * Renders the score component.
 *
 * @returns {JSX.Element} Score component
 */
export default function Score({ score }: Props) {
  return score ? (
    <Container id='score'>
      <Star />
      <Numerator id='scoreText'>{score}</Numerator>
      <Denominator>{DENOMINATOR}</Denominator>
    </Container>
  ) : null;
}
